import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=4c898c58&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=4c898c58&scoped=true&lang=stylus"
import style1 from "./Shop.vue?vue&type=style&index=1&id=4c898c58&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c898c58",
  null
  
)

export default component.exports